import { render } from "./CustomerMenu.vue?vue&type=template&id=40dbb6ba&scoped=true"
import script from "./CustomerMenu.vue?vue&type=script&lang=js"
export * from "./CustomerMenu.vue?vue&type=script&lang=js"

import "./CustomerMenu.vue?vue&type=style&index=0&id=40dbb6ba&scoped=true&lang=css"

import exportComponent from "/Users/victorbello/Documents/Tizeti/Hotspot/eutelsat_branch/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40dbb6ba"]])

export default __exports__